
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/retailer-pages",
      function () {
        return require("private-next-pages/stores/retailer-pages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/retailer-pages"])
      });
    }
  